module.exports = __webpack_public_path__ + "img/SD-52.82ef351f.png";